import SVGIconWrapper from "./SVGIconWrapper"

const IconProfile = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 72 77.5"
        iconClass={`icon--profile ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M36,41.8c4.2,0,8.1-1.8,11.2-4.7c4.2-4.1,6.9-10.4,6.9-17.5C54.1,7.2,46,0,36,0C26,0,17.9,7.2,17.9,19.5C17.9,31.8,26,41.8,36,41.8z M50.4,39.9c-0.2,0.2-0.3,0.3-0.5,0.5C46,44.2,41,46.3,36,46.3c-5.5,0-10.5-2.4-14.3-6.4C14.3,43.8,3.4,54,0,62.5c0,0,11.7,14.9,34.7,14.9S72,62.5,72,62.5C68.6,54,57.8,43.8,50.4,39.9z" />
    </SVGIconWrapper>
)

export default IconProfile